const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value)

const normalizeZero = (value: number) => (Object.is(value, -0) ? 0 : value)

export const roundUp = (value: number, decimals = 0) => {
  const factor = Math.pow(10, decimals)
  return Math.round(Number((value * factor).toPrecision(12))) / factor
}

export const formatDecimal = (value: unknown, decimals: number) =>
  isNumber(value) ? String(normalizeZero(roundUp(value, decimals))) : ''

export const formatInteger = (value: unknown) => formatDecimal(value, 0)

export const formatPercentage = (value: unknown, decimals = 1) =>
  isNumber(value) ? `${formatDecimal(value, decimals)}%` : ''

export const formatMoney = (value: unknown) =>
  isNumber(value) ? normalizeZero(roundUp(value, 2)).toFixed(2) : ''

const groupedFormat = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2
})

export const formatGridNumber = (value: unknown, emptyValue = '') =>
  value != null ? groupedFormat.format(Number(value)) : emptyValue

export const formatValueWithCurrency = (
  value: string | number,
  currency: string
) => {
  const stringValue = `${value}`

  if (!currency) return stringValue

  return `${stringValue} ${currency}`
}

export const hasExceededMaximumFractionDigits = (
  maximumFractionDigits,
  value
) => {
  if (maximumFractionDigits && value.includes('.')) {
    const parts = value.split('.')
    return parts[1] && parts[1].length > maximumFractionDigits
  }

  return false
}

export const validateMaximumFractionDigitsOnBeforeInput = (
  e,
  maximumFractionDigits
) => {
  const { data: key, target } = e
  const currentValue = target.value

  if (
    hasExceededMaximumFractionDigits(maximumFractionDigits, currentValue + key)
  ) {
    e.preventDefault()
  }
}
